
import { ThemeProvider } from './theme-provider';
import { AuthProvider } from './auth-provider';
import { NotificationsProvider } from './notifications-provider';

if (typeof window !== 'undefined' && !(window as any).__name) {
  (window as any).__name = function (target: any, value: string) {
    if (target) {
      Object.defineProperty(target, 'name', { value, configurable: true });
    }
    return target;
  };
}

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ThemeProvider>
      <AuthProvider>
        <NotificationsProvider>
          {children}
        </NotificationsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
